import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { clickOutside as vClickOutside } from "@/directives/clickOutside";


export default /*#__PURE__*/_defineComponent({
  __name: 'DropDown',
  props: {
  placement: {
    type: String,
    default() {
      return "left bottom";
    },
  },
  width: {
    type: String,
  },
},
  emits: ["open", "close"],
  setup(__props, { expose: __expose, emit: emits }) {
  __expose();

const props = __props;



const showDropDown = ref(false);

function toggleDropdown() {
  showDropDown.value = !showDropDown.value;
  showDropDown.value ? emits("open") : emits("close");
}

function closeDropDown() {
  showDropDown.value = false;
}

const __returned__ = { emits, props, showDropDown, toggleDropdown, closeDropDown, ref, get vClickOutside() { return vClickOutside } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})